module.exports = __webpack_public_path__ + "assets/img/news2.5.7360d2a5.png";